import { Notify } from 'quasar'

export const Mutations = {
  PUSH_ERROR: 'μ: Push error to log',
  PUSH_WARNING: 'μ: Push warning to log',
  UPDATE_ERROR: 'μ: Update error in log',
  PUSH_NOTIFICATION: 'μ: Push notification to log',
  REMOVE_LAST_NOTIFICATION: 'μ: Remove last notification from log',
}

export const Actions = {
  LOG_ERROR: '🪲 Log error',
  HIDE_ERROR: '🫥 Hide error',
  NOTIFY_USER: '🔔 Notify user',
}

const log = {
  namespaced: false,
  state: {
    errors: [],
    warnings: [],
    notifications: [],
  },
  getters: {
    errors(state) {
      return state.errors
    },
    warnings(state) {
      return state.warnings
    },
  },
  mutations: {
    [Mutations.PUSH_ERROR](state, error) {
      state.errors.push(error)
    },
    [Mutations.PUSH_WARNING](state, warning) {
      state.warnings.push(warning)
    },
    [Mutations.UPDATE_ERROR](state, error) {
      state.errors = state.errors.map((e) => {
        if (e.id === error.id) {
          return { ...e, ...error }
        }
        return e
      })
    },
    [Mutations.PUSH_NOTIFICATION](state, notification) {
      state.notifications.push(notification)
    },
    [Mutations.REMOVE_LAST_NOTIFICATION](state) {
      if (state.notifications.length) {
        state.notifications.at(-1)() // will dismiss last notification
      } else {
        console.debug('Notifications array is empty')
      }
      state.notifications.pop()
    },
  },
  actions: {
    [Actions.LOG_ERROR](context, { error, errorType = 'error', debugContext = null }) {
      // TODO: make console log optional?
      if (errorType === 'warning') console.warn('[Warning log]', error)
      else console.error('[Error log]', error)
      // Give unique ID to error
      error.id = `${Date.now()}.${Math.random()}`
      error.type = errorType
      if (debugContext) {
        error.debug = error.debug || {}
        error.debug.context = { ...(error.debug.context || {}), ...debugContext }
      }
      context.commit(Mutations.PUSH_ERROR, error)
    },
    [Actions.HIDE_ERROR](context, errorId) {
      context.commit(Mutations.UPDATE_ERROR, { id: errorId, hidden: true })
    },
    [Actions.NOTIFY_USER](context, opts) {
      const notification = Notify.create({
        ...opts,
        timeout: 0, // will keep the notification from being automatically dismissed after the default duration
      })

      context.commit(Mutations.PUSH_NOTIFICATION, notification)

      setTimeout(() => {
        context.commit(Mutations.REMOVE_LAST_NOTIFICATION)
      }, 5000)
    },
  },
}

export default log
